export default __webpack_public_path__ + "img/d5051a96c2d038240372bb443c845899.svg";